export default class PlzInputObserver {
  constructor(handler) {
    this.handler = handler;
  }
  notify(eventName, input) {
    this.handler(eventName, input);
  }
}
